import { useEffect, useRef, useState } from "react";
import { Pause, Play, Volume2, VolumeX } from "lucide-react";
import { asset } from "../lib/api";

const fmt = (s) => (isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}` : "0:00");

export const MusicPlayer = ({ src, title, accent, autoPlay }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [t, setT] = useState(0);
  const [d, setD] = useState(0);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    const a = ref.current;
    if (!a) return;
    a.volume = 0.5;
    if (autoPlay) a.play().then(() => setPlaying(true)).catch(() => {});
  }, [autoPlay, src]);

  const toggle = () => {
    const a = ref.current;
    if (playing) { a.pause(); setPlaying(false); } else { a.play().then(() => setPlaying(true)).catch(() => {}); }
  };
  const seek = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    ref.current.currentTime = ((e.clientX - r.left) / r.width) * d;
  };

  return (
    <div data-testid="profile-music-player" className="flex w-full items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-3 py-2.5 backdrop-blur-md">
      <audio ref={ref} src={asset(src)} loop muted={muted} onTimeUpdate={(e) => setT(e.target.currentTime)} onLoadedMetadata={(e) => setD(e.target.duration)} />
      <button data-testid="music-play-toggle" onClick={toggle} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white transition-transform active:scale-90" style={{ background: accent, boxShadow: `0 0 16px ${accent}66` }}>
        {playing ? <Pause className="h-4 w-4" /> : <Play className="ml-0.5 h-4 w-4" />}
      </button>
      <div className="min-w-0 flex-1">
        <div className="truncate text-xs font-semibold text-white">{title || "untitled track"}</div>
        <div className="mt-1.5 flex items-center gap-2">
          <div onClick={seek} className="h-1 flex-1 cursor-pointer overflow-hidden rounded-full bg-white/10">
            <div className="h-full rounded-full transition-[width] duration-200" style={{ width: `${d ? (t / d) * 100 : 0}%`, background: accent }} />
          </div>
          <span className="font-mono text-[10px] text-zinc-400">{fmt(t)}</span>
        </div>
      </div>
      <button data-testid="music-mute-toggle" onClick={() => setMuted(!muted)} className="text-zinc-400 transition-colors hover:text-white">
        {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
      </button>
    </div>
  );
};
